import Vue from "vue";

// Tipo pedido por um atalho de rota (ex.: /dashboard/folhaCalculo/rescisoes). Vindo de outra tela, a folha recebe o
// tipo pelos parâmetros da rota; já aberta, o redirecionamento para a mesma rota é descartado pelo vue-router e o
// pedido chega por aqui.
export const pedidoTipoFolha = Vue.observable({ tipo: null, vez: 0 });

export function pedirTipoFolha(tipo) {
  pedidoTipoFolha.tipo = tipo;
  pedidoTipoFolha.vez++;
}
